import React from "react";
import Dashboard from "../components/Dashboard";

const DashboardPage = () => {
  return (
    <div className="piq-body">
      <Dashboard />
    </div>
  );
};

export default DashboardPage;
